import { UseLanguageReturn } from '@/utils/hooks/useLanguage';
import { portalDepositColumns } from './portalDepositHelper';

interface PortalWithdrawalColumnsParams {
    lang: UseLanguageReturn;
    formatQty: Intl.NumberFormat;
    formatDate: Intl.DateTimeFormat;
}

export const portalWithdrawalColumns = (params: PortalWithdrawalColumnsParams) => {
    return portalDepositColumns(params);
};
